export default __webpack_public_path__ + "static/tab-client002-9e98f261343d57bf337aa8c6f0cf3ebb.png";